import Vue from 'vue';
import Router from 'vue-router';

import store from '../store';

import CompetitionDeck from '../components/CompetitionDeck.vue';
import EventDeck from '../components/EventDeck.vue';
import Login from '../components/Login.vue';
import EventData from '../components/EventData.vue';
import StartList from '../components/StartList.vue';
import EditResult from '../components/EditResult.vue';
import HeightManager from '../components/HeightManager.vue';
import EditEntrie from '../components/EditEntrie';
import DropStartlist from '../components/DropStartlist.vue'
import Settings from '../components/Settings'


Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
    {
        path: '/dashboard/',
        component: CompetitionDeck,
            children: [{
                path: ':cId/login/:hId',
                component: Login,
                name: 'Login',
                meta: {
                    requiresCId: true
                },

            }, {
                    path: 'login/',
                    component: Login,
                    name: 'Login',
                    meta: {
                        requiresCId: true
                    },

            },{
                path: '*',
                redirect: "/dashboard/",
                name: 'Dashboard'
            }]
    }, 
    {
        path: '/competition/events/',
        component: EventDeck,
        meta: {
            requiresAuth: true
        },
        children: [{
            path: 'event/',
            component: EventData,
            children: [{
                path: 'startlist',
                component: StartList
            }, {
                path: 'heightManager/',
                component: HeightManager,
            }, {
                path: 'drop/',
                    component: DropStartlist,
            }, {
                path: 'editResult/',
                component: EditResult,
            }, {
                path: 'editEntrie/',
                component: EditEntrie,
            }, {
                path: '',
                redirect: 'startlist'
            }]
        },{
            path: 'settings/',
            component: Settings,
        }]
    },
    {
        path: '*',
        redirect: '/dashboard'
    }
]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.IsAuthenticated) {
            next({ name: 'Login' });
        } else {
            next();
        }
    } else {
        if (to.matched.some(record => record.meta.requiresCId)) {
            if (store.getters.CId === "") {
                next({ name: 'Dashboard' });
            } else {
                next();
            }
        } else {
            next();
        }

    }
})

export default router;